.region {
  position: fixed;
  left: 50%;
  /* Een vaste knoppenbalk onderaan (opslagbalk) meldt zijn hoogte als --fixed-actions-h: de
     melding staat erboven, nooit over Opslaan (review golf 6b founder-ux r1). */
  bottom: max(16px, env(safe-area-inset-bottom), calc(var(--fixed-actions-h, 0px) + 12px));
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  width: min(560px, calc(100% - 32px));
  transform: translateX(-50%);
  pointer-events: none;
}

/* In een modaal venster (toplaag): zelfde plek, maar boven de achtergrond en klikbaar. */
.inDialog {
  z-index: 2;
}

/* Sheet: de melding staat boven de knoppenbalk van de sheet, nooit over Bewerken of Opslaan
   (Dialog.tsx meet de balk; review c-ux r3). De sheet houdt zolang ruimte vrij (--dialog-toast-h). */
.inSheet {
  bottom: calc(var(--dialog-actions-h, 0px) + 12px);
}

/* Sheet rechts op brede schermen (480 px): de melding staat onderaan in de sheet. */
@media (min-width: 720px) {
  .inSheet {
    inset-inline-start: auto;
    inset-inline-end: 16px;
    width: 448px;
    transform: none;
  }
}

.toast {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  min-height: 52px;
  padding: 8px 8px 8px var(--space-4);
  border-radius: var(--radius-lg);
  background: var(--text);
  color: var(--surface-panel);
  box-shadow: var(--shadow-3);
  font-size: var(--b-text-body);
  pointer-events: auto;
  animation: toast-in var(--dur-slow) var(--ease-out);
}

.icon {
  flex: 0 0 auto;
}

.success .icon {
  color: #8fd3b4;
}

.error .icon {
  color: #f3a585;
}

.message {
  flex: 1 1 auto;
  min-width: 0;
}

.action {
  flex: 0 0 auto;
  min-height: 40px;
  padding: 0 var(--space-3);
  border: 0;
  border-radius: var(--radius-pill);
  background: rgba(255, 255, 255, 0.14);
  color: inherit;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.action:hover {
  background: rgba(255, 255, 255, 0.22);
}

.dismiss {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  opacity: 0.75;
  cursor: pointer;
}

.dismiss:hover {
  opacity: 1;
}

.action:focus-visible,
.dismiss:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 1px;
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

/* Telefoon: "Ongedaan maken" naast de tekst liet maar een smalle kolom over ("Baba / brengt /
   deze / keer"). Dan staat de tekst met het kruisje op de eerste regel en de actie rechts eronder. */
@media (max-width: 480px) {
  .toast {
    flex-wrap: wrap;
    row-gap: 2px;
  }

  .message {
    flex-basis: calc(100% - 96px);
  }

  .dismiss {
    order: 1;
  }

  .action {
    order: 2;
    margin-inline-start: auto;
  }
}
